import(/* webpackMode: "eager" */ "/var/www/xhub/frontend/live/app/courses/CoursesPage.tsx")